document.addEventListener("DOMContentLoaded", function (event) {


    function localizationFormSubmit(event) {
        event.target.form.submit();
    }

    document.querySelectorAll('.shopify-localization-form select').forEach(function (element) {
        element.addEventListener('change', localizationFormSubmit);

    });



    $('.nav-item.has-megamenu > a').on('click', function (e) {
        var ww = $(window).width()

        if (ww < 992) {
            e.preventDefault()
            console.log('..mmob')
            var isOpen = $('body').hasClass('nav-subopen')

            if (isOpen) {

                $('.nav-item.has-megamenu > a').each(function () {
                    $(this).removeClass('show')
                    $(this).attr('aria-expanded', 'false')
                    $(this).siblings('.megamenu').removeClass('show')
                })
                $('body').removeClass('nav-subopen')

            } else {
                $(this).addClass('show')
                $(this).attr('aria-expanded', 'true')
                $(this).siblings('.megamenu').addClass('show')
                $('body').addClass('nav-subopen')
            }

        }

        var mm = $(this).parent().find('.megamenu')

    })



    $('.qty__input_cart').on('change', function () {
        var qty = $(this).val();
        var vid = $(this).attr('data-vid');

        $.post('/cart/change.js', {
            'id': vid,
            'quantity': qty
        }).then(function () {
            window.location = window.location;
        })

    })




    $('input#giftMsgCheck').on('change', function () {
        if ($(this).is(":checked")) {
            $('#shownote').slideDown()

        }
        else {
            $('#shownote').slideUp()
        }

    })

    $('li.nav-item.dropdown.has-megamenu').on('mouseenter', function () {
        var link = $(this).find('.nav-link.dropdown-toggle')
        var menu = $(this).find('.dropdown-menu.megamenu')

        $(link).attr('aria-expanded', 'true').addClass('show')
        $(menu).addClass('show')

    })


    $('li.nav-item.dropdown.has-megamenu').on('mouseleave', function () {
        var link = $(this).find('.nav-link.dropdown-toggle')
        var menu = $(this).find('.dropdown-menu.megamenu')

        $(link).attr('aria-expanded', 'false').removeClass('show')
        $(menu).removeClass('show')

    })

    $('.dropdown-menu.megamenu.show').on('mouseleave', function () {
        var link = $(this).parent().find('.nav-link.dropdown-toggle')
        var menu = $(this).parent().find('.dropdown-menu.megamenu')

        $(link).attr('aria-expanded', 'false').removeClass('show')
        $(menu).removeClass('show')

    })

    $('.product-item-qty.form-control').on('change', function () {


        $(this).parents('.cart-product-item').find('.update-btn').removeClass('v-none').removeClass('d-none');


    })


    $('.locale-selectors__selector').on('change', function () {


        var form = $(this).parents('form')

        form.submit();

    })





    $('.update-btn.btn').on('click', function () {


        var form = $(this).parents('form')

        form.submit();

    })


    $('[data-q]').on('click', function (e) {

        e.preventDefault();

        var ud = $(this).attr('data-q')
        var inptel = $(this).siblings('input.product-item-qty')
        var inpt = $(inptel).val()
        var current = parseInt(inpt)

        if (ud == 'up') {
            $(inptel).val(current + 1)
        } else {
            $(inptel).val(current - 1)

            if (current == 0) {
                $(inptel).val(0)
            }

        }

        $(this).parents('.cart-product-item').find('.update-btn').removeClass('v-none').removeClass('d-none');





    })


    window.addEventListener('scroll', function () {
        if (window.scrollY > 100) {
            document.getElementById('body').classList.add('scrolled');
            document.getElementById('navbar').classList.add('fixed-top');

            navbar_height = document.querySelector('.navbar').offsetHeight;
            document.body.style.paddingTop = navbar_height + 'px';
        } else {
            document.getElementById('body').classList.remove('scrolled');
            document.getElementById('navbar').classList.remove('fixed-top');
            document.body.style.paddingTop = '0';
        }

        //  $('.megamenu').removeClass('show')
        $('#search_pop').removeClass('show')
        $('button[data-bs-target="#search_pop"]').attr('aria-expanded', 'false')


    });


    $('#feefstar').on('mouseup', function () {
        $(".accordion-collapse.reviews").collapse('show');
    });






});

$(window).on('load', function () {

    setTimeout(function () {


        var eu_select_wrap = $('body').find('.locale-selectors__container')
        var eu_select = $(eu_select_wrap).find('.locale-selectors__selector')
        var eu_option = $(eu_select).find('option[value="IE"]')
        $(eu_option).html('E.U.  (EUR €)')
        console.log(eu_option)
    }, 1000)


})
